import DrdRenderer from './DrdRenderer';
import PathMap from './PathMap';

export default {
  __init__: [ 'drdRenderer' ],
  drdRenderer: [ 'type', DrdRenderer ],
  pathMap: [ 'type', PathMap ]
};
